import { defineNuxtPlugin } from '#app';
import { configure, defineRule } from 'vee-validate';
import { localize, setLocale } from '@vee-validate/i18n';
import fr from '@vee-validate/i18n/dist/locale/fr.json';
import { all } from '@vee-validate/rules';

export default defineNuxtPlugin((nuxtApp) => {
    Object.entries(all).forEach(([name, rule]) => {
        defineRule(name, rule);
    });
    configure({
        generateMessage: localize({
            fr
        }),
    });
    setLocale('fr');
});